import { Get, Post } from "./apiUtils";

const validateToken = async () => {
  const response = await Get("/api/account");
  const result = await response.text();
  return result;
};

const getUserRolesAsync = async (groupIds: string[]): Promise<string[]> => {
  const response = await Post(
    `/api/account/userroles`,
    JSON.stringify(groupIds)
  );
  const result = await response.json();
  return result;
};

const updateUserProfileAsync = async (profilePicture: string) => {
  const response = await Post(
    `/api/account/userProfile`,
    JSON.stringify(profilePicture)
  );
};

const getUserGroupsAsync = async (): Promise<string> => {
  const response = await Get("/api/account/usergroups");
  const result = await response.json();
  return result;
};

export const accountApi = {
  validateToken,
  getUserRolesAsync,
  getUserGroupsAsync,
  updateUserProfileAsync,
};
